import { render, staticRenderFns } from "./Vidcents.vue?vue&type=template&id=509c24d0&scoped=true"
import script from "./Vidcents.vue?vue&type=script&lang=js"
export * from "./Vidcents.vue?vue&type=script&lang=js"
import style0 from "./Vidcents.vue?vue&type=style&index=0&id=509c24d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c24d0",
  null
  
)

export default component.exports